// eslint-disable-next-line import/prefer-default-export

export const validateEmail = (value) => {
    // if the field is empty
    if (!value) {
        return 'This field is required';
    }
    // if the field is not a valid email
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!regex.test(value)) {
        return 'This field must be a valid email';
    }
    // All is good
    return true;
};

export const isValidPesel = (pesel = '') => {
    const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    let sum = 0;
    const controlNumber = parseInt(pesel.substring(10, 11));

    for (let i = 0; i < weight.length; i++) {
        sum += parseInt(pesel.substring(i, i + 1)) * weight[i];
    }
    sum %= 10;
    return (10 - sum) % 10 === controlNumber;
};

export const isValidNip = (nip) => {
    if (typeof nip !== 'string') return false;

    if (nip.length !== 10) return false;

    nip = nip.replace(/[\ \-]/gi, '');

    const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    const controlNumber = parseInt(nip.substring(9, 10));
    const weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
        sum += parseInt(nip.substr(i, 1)) * weight[i];
    }

    return sum % 11 === controlNumber;
};

export const validatePdfFormatFile = (file) => {
    const allowedExtensions = ['application/pdf', 'image/jpg', 'image/png', 'image/jpeg'];

    if (file.size > 5000000) {
        alert('Plik jest zbyt duży, maksymalnie 5MB');
        return false;
    }

    if (!allowedExtensions.includes(file.type)) {
        alert('Niepoprawny format pliku');
        return false;
    }
    return true;
};
